/* eslint-disable prefer-object-spread */
import { createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../../data/axiosInstance/axiosInstance';
import executor from '../../../data/axiosInstance/executor';
import { EnabledDisabledStateTrueFalsePresaCarico } from '../../customizer/CustomizerSlice';
import { removeTaskToNav } from '../addNavTask/AddNavTaskSlice';
import { checkTotalItemMessageToast, setTotalItemMessageToast } from '../ws/WsSlice';

const API_URL = `${process.env.REACT_APP_API_SINISTRI_URL}`;

const initialState = {
  ticketsLavorabili: [],//Tutti i ticket visualizzati nella gridLavorabili
  ticketsAssegnate: [],//Tutti i ticket visualizzati nella gridAssegnate
  currentFilter: 'total_tickets',//To do gestione filtri grid
  ticketSearch: '',//To do Gestione Filtri
  openedTicket: {},//
  //setAdminData: {},
  allOpenedTicket: [],
  totalOpenedTicket: 0,
  taskId: '',
  loading: false,
  taskIdInCharge: '',
  userData: {}
};

export const TicketSlice = createSlice({
  name: 'ticket', 
  initialState,
  reducers: {
    getTicketsLavorabili: (state, action) => {
      //state.ticketsLavorabili = {};
      if(action.payload)
        state.ticketsLavorabili = action.payload;
    },
    getTicketsAssegnate: (state, action) => {
      // state.ticketsAssegnate = {};
      if(action.payload)
        state.ticketsAssegnate = action.payload;
    },
    getTicket: (state, action) => {
      state.openedTicket = {};
      state.openedTicket = { ...{}, ...action.payload };
    },
    getTicketTree: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index=state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask === action.payload.datiTask.idTask);
      if (index !== -1) {
        state.allOpenedTicket[index].datiTaskFigli =action.payload?.datiTaskFigli;
      }
    }, 
    setVisibilityFilter: (state, action) => {//NOTUSED
      state.currentFilter = action.payload;
    },
    SearchTicket: (state, action) => {//NOTUSED
      state.ticketSearch = action.payload;
    },
    DeleteTicket: (state, action) => {//NOTUSED
      const index = state.tickets.findIndex((ticket) => ticket.Id === action.payload);
      state.tickets.splice(index, 1);
    },
    setOpenedTicketClaimData: (state, action) => {//
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      //dopo aver reperito il ticket dallo store, lo popoliamo con i dati denuncia
      // const tckObject = Object.assign({}, state.openedTicket?.datiDenuncia);
      // state.allOpenedTicket[index].datiDenuncia = { ...tckObject };
      state.openedTicket.datiDenuncia = { ...action.payload };
      state.allOpenedTicket[index].datiDenuncia = { ...action.payload };
      //this is shit we have to refactor denuncia
      state.allOpenedTicket[index].datiDenuncia.titoloAmministrativoId = state.openedTicket?.datiDenuncia.titoloAmministrativoId;
    },
    setOpenedTicketDatiCausa: (state, action) => {//
      //state.openedTicket.datiDenuncia = { ...state.openedTicket.datiDenuncia, ...action.payload}; old

      //cerca tra i ticket aperti quello uguale a quello attualmente visualizzato e aggiornalo
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      //dopo aver reperito il ticket dallo store, lo popoliamo con i dati denuncia
      const tckObject = Object.assign({}, state.openedTicket?.datiCausa);
      state.allOpenedTicket[index].datiCausa = { ...tckObject };
      state.allOpenedTicket[index].datiCausa = { ...action.payload };
    },
    setOpenedTicketDatiIncarico: (state, action) => {//
      //state.openedTicket.datiDenuncia = { ...state.openedTicket.datiDenuncia, ...action.payload}; old

      //cerca tra i ticket aperti quello uguale a quello attualmente visualizzato e aggiornalo
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      //dopo aver reperito il ticket dallo store, lo popoliamo con i dati denuncia
      const tckObject = Object.assign({}, state.openedTicket?.datiIncarico);
      state.allOpenedTicket[index].datiIncarico = { ...tckObject };
      state.allOpenedTicket[index].datiIncarico = { ...action.payload };
    },
    setOpenedTicketAdminData: (state, action) => {//
      //state.setAdminData = {};
      //state.openedTicket.datiDenuncia.titoloAmministrativoId = action.payload;  //old

      //cerca tra i ticket aperti quello uguale a quello attualmente visualizzato e aggiornalo
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      state.openedTicket.datiDenuncia.titoloAmministrativoId = action.payload;
      //dopo aver reperito il ticket dallo store, lo popoliamo con i dati denuncia
      const tckObject = Object.assign({}, state.openedTicket?.datiDenuncia);
      state.allOpenedTicket[index].datiDenuncia = { ...tckObject };
      state.allOpenedTicket[index].datiDenuncia.titoloAmministrativoId = action.payload;
    },
    setOpenedTicketAdminDataRender: (state, action) => {//
      //state.setAdminData = {};
      //state.openedTicket.datiDenuncia.titoloAmministrativoId = action.payload;  //old

      //cerca tra i ticket aperti quello uguale a quello attualmente visualizzato e aggiornalo
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      //dopo aver reperito il ticket dallo store, lo popoliamo con i dati denuncia
      // const tckObject = Object.assign({}, state.openedTicket?.adminDataRender);
      // state.allOpenedTicket[index].adminDataRender = { ...tckObject };
      state.openedTicket.adminDataRender = action.payload;
      state.allOpenedTicket[index].adminDataRender = action.payload;
    },
    setOpenedTicketNPolizza: (state, action) => {//
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      //const tckObject = Object.assign({}, state.openedTicket?.datiTask?.nPolizza);
      //state.allOpenedTicket[index].datiTask.nPolizza = { ...tckObject };
      state.openedTicket.datiTask.nPolizza = action.payload;
      state.allOpenedTicket[index].datiTask.nPolizza = action.payload;
    },
    setDenunciaMotivazione: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.datiDenuncia?.motivazione);
      state.allOpenedTicket[index].datiDenuncia.motivazione = { ...tckObject };
      state.allOpenedTicket[index].datiDenuncia.motivazione = action.payload;
      state.openedTicket.datiDenuncia.motivazione = action.payload; //this is shit, we will correct on alert
    },
    setTipoIncaricato: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.tipoIncaricato);
      state.allOpenedTicket[index].tipoIncaricato = { ...tckObject };
      state.allOpenedTicket[index].tipoIncaricato = action.payload;
    },
    setIdTicketInCharge: (state, action) => {
      if (!state.taskIdInCharge.includes(action.payload)) {  //se il ticket non è già in carico aggiungilo alla lista
        const oldTaskIdInCharge = state.taskIdInCharge;
        state.taskIdInCharge = '';
        state.taskIdInCharge = oldTaskIdInCharge.concat(action.payload, ";");
      }
    },
    removeIdTicketInCharge: (state, action) => {
      const oldTaskIdInCharge = state.taskIdInCharge;
      state.taskIdInCharge = '';
      state.taskIdInCharge = oldTaskIdInCharge.replace(action.payload.toString().concat(";"), "");
    },
    addOpenedTicket: (state, action) => {
      // eslint-disable-next-line eqeqeq
      if (state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask === action.payload.datiTask.idTask) === -1) {
        state.allOpenedTicket = [...state.allOpenedTicket, action.payload];
        state.totalOpenedTicket += 1;
      }
      state.taskId = {};
      state.taskId = action.payload.datiTask.idTask;  //aka getIdTicket
      state.openedTicket = {};
      state.openedTicket = Object.assign({}, action.payload);
    },
    setOpenedTicketChangePolizza: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index=state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask === action.payload.datiTask.idTask);
      if (index !== -1) {
        state.allOpenedTicket.splice(index,1);
        state.allOpenedTicket = [...state.allOpenedTicket, action.payload];
      }
    },
    addOpenedTicketCached: (state, action) => {
     // eslint-disable-next-line eqeqeq
      const tckObject =  {...state.allOpenedTicket[(state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == action.payload.datiTask.idTask))]};
      state.taskId = {};
      state.taskId = tckObject.datiTask.idTask;  //aka getIdTicket
      state.openedTicket = {};
      state.openedTicket = Object.assign({}, tckObject);
    },
    removeOpenedTicket: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == action.payload.taskId);
      state.allOpenedTicket.splice(index, 1);
      state.totalOpenedTicket -= 1;
      state.taskId = {};
      state.openedTicket = {};
      state.taskId = (state.totalOpenedTicket > 0) ? state.allOpenedTicket[state.totalOpenedTicket - 1].datiTask.idTask : '0';
      state.openedTicket = (state.totalOpenedTicket > 0) ? Object.assign({}, state.allOpenedTicket[state.totalOpenedTicket - 1]) : {};
    },
    setModifiedTicket: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == action.payload.taskId);
      state.allOpenedTicket[index] = Object.assign({}, action.modTicket);
    },
    resetModifiedTicket: (state) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      state.allOpenedTicket[index] = Object.assign({}, state.openedTicket);
      //identifica il ticket in lavorazione e resetta il risultato ovvero aggiorna redux
    },
    toogleLoading: (state) => {
      state.loading = !state.loading;
    },
    getListaDanneggiati: (state, action) => {
      state.openedTicket.listaDanneggiati = action.payload;
    },
    getListaSoggettiCause: (state, action) => {
      state.openedTicket.datiCausa.listaSoggetti = action.payload;
    },
    setListaSoggettiCausa: (state, action) => {
      state.openedTicket.datiCausa.listaSoggetti = action.payload;
    },
    getRamiSinistro: (state, action) => {
      state.openedTicket.listaRamiSinistro = action.payload;
    },
    VisibleAlertDangerMora: (state, action) => {
      state.openedTicket.alertDangerVisible = action.payload;
    },
    VisibleAlertWarningMora: (state, action) => {
      state.openedTicket.alertWarningVisible = action.payload;
    },
    VisibleAlertNoDataEvDataRis: (state, action) => {
      state.openedTicket.alertNoDataEvntoDataRis = action.payload;
    },
    setTitoloIsInCopertura: (state, action) => {
      state.openedTicket.isInCopertura = action.payload;
    },
    getGaranzieDanneggiato: (state, action) => {
      state.openedTicket.listaGaranzieDanneggiato = action.payload;
    },
    setRamoGaranzia: (state, action) => {
      state.openedTicket.ramoGaranziaPut = action.payload;
    },
    setRamoGaranziaDanneggiato: (state, action) => {
      state.openedTicket.ramoGaranziaDanneggiato = action.payload;
    },
    getPrecedentiSinistri: (state, action) => {
      state.openedTicket.precedentiSinistri = action.payload;
    },
    getRiserveComplessive: (state, action) => {
      state.openedTicket.riserveComplessive = action.payload;
    },
    getCauseIstruttoria: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.causeIstruttoria);
      state.allOpenedTicket[index].causeIstruttoria = { ...tckObject };
      state.allOpenedTicket[index].causeIstruttoria = action.payload;
    },
    getIncarichiIstruttoria: (state, action) => {
      state.openedTicket.incarichiIstruttoria = action.payload;
    },
    getValidazioniIstruttoria: (state, action) => {
      state.openedTicket.validazioniIstruttoria = action.payload;
    },
    addIncaricato: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.incaricato);
      state.allOpenedTicket[index].incaricato = { ...tckObject };
      state.allOpenedTicket[index].incaricato = action.payload;
    },
    removeIncaricato: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.datiIncarico?.incaricato);
      state.allOpenedTicket[index].datiIncarico.incaricato = { ...tckObject };
      state.allOpenedTicket[index].datiIncarico.incaricato = action.payload;
    },
    showAlertIncaricato: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.alertIncaricato);
      state.allOpenedTicket[index].alertIncaricato = { ...tckObject };
      state.allOpenedTicket[index].alertIncaricato = action.payload;
    },
    getListaIncaricatiInQuadro: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.listaIncaricatiInQuadro);
      state.allOpenedTicket[index].listaIncaricatiInQuadro = { ...tckObject };
      state.allOpenedTicket[index].listaIncaricatiInQuadro = action.payload;
    },
    getListaIncaricatoNoQuadro: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.listaIncaricatoNoQuadro);
      state.allOpenedTicket[index].listaIncaricatoNoQuadro = { ...tckObject };
      state.allOpenedTicket[index].listaIncaricatoNoQuadro = action.payload;
    },
    setIdCauseCollegate: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.idsCauseCollegate);
      state.allOpenedTicket[index].idsCauseCollegate = { ...tckObject };
      state.allOpenedTicket[index].idsCauseCollegate = action.payload;
    },
    getRiservaSpeseIncarico: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.riservaSpeseIncarico);
      state.allOpenedTicket[index].riservaSpeseIncarico = { ...tckObject };
      state.allOpenedTicket[index].riservaSpeseIncarico = action.payload;
    },
    setMotivazioneIncarico: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.motivazioneIncarico);
      state.allOpenedTicket[index].motivazioneIncarico = { ...tckObject };
      state.allOpenedTicket[index].motivazioneIncarico = action.payload;
    },
    setMotivazioneIncaricoNoQuadro: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.motivazioneIncaricoNoQuadro);
      state.allOpenedTicket[index].motivazioneIncaricoNoQuadro = { ...tckObject };
      state.allOpenedTicket[index].motivazioneIncaricoNoQuadro = action.payload;
    },
    setNotaRiserveAuthority: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.notaRiserveAuthority);
      state.allOpenedTicket[index].notaRiserveAuthority = { ...tckObject };
      state.allOpenedTicket[index].notaRiserveAuthority = action.payload;
    },
    setNotaRiserveAuthorityPagamento: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.notaRiserveAuthorityPagamento);
      state.allOpenedTicket[index].notaRiserveAuthorityPagamento = { ...tckObject };
      state.allOpenedTicket[index].notaRiserveAuthorityPagamento = action.payload;
    },
    setDisableComponentIncarico: (state, action) =>{
       // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.disableComponentIncarico);
      state.allOpenedTicket[index].disableComponentIncarico = { ...tckObject };
      state.allOpenedTicket[index].disableComponentIncarico = action.payload;
    },
    getListaSearchPolizza: (state, action) =>{
      state.openedTicket.listaSearchPolizza = action.payload;
    },
    getListaSearchPolizzaCollettiva : (state, action) =>{
      state.openedTicket.listaSearchPolizzaCollettiva = action.payload;
    },
    getListaSearchCollettiva: (state, action) => {
      state.openedTicket.listaSearchCollettiva = action.payload;
    },
    setPolizza: (state, action) =>{
        state.openedTicket.setPolizza = action.payload;
    },
    setPolizzaTempAmministrativo: (state, action) =>{
      state.openedTicket.setPolizzaTempAmministrativo = action.payload;
    },
    setNotaPromemoria: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.datiAppuntamento?.nota);
      state.allOpenedTicket[index].datiAppuntamento.nota = { ...tckObject };
      state.allOpenedTicket[index].datiAppuntamento.nota = action.payload;
    },
    getListaPagamentiIstruttoria: (state, action) =>{
      state.openedTicket.listaPagamenti = action.payload;

   },
    setAlertPagamentiSpese: (state, action) =>{
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.alertSimplePagamanetiSpese);
      state.allOpenedTicket[index].alertSimplePagamanetiSpese = { ...tckObject };
      state.allOpenedTicket[index].alertSimplePagamanetiSpese = action.payload;
   },

   setAlertPagamentiIndennizzoBeneficiari: (state, action) =>{
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.alertSimplePagamentiIndennizzoBeneficiari);
      state.allOpenedTicket[index].alertSimplePagamentiIndennizzoBeneficiari = { ...tckObject };
      state.allOpenedTicket[index].alertSimplePagamentiIndennizzoBeneficiari = action.payload;
   },

   getListaDanneggiatiJmil: (state, action) =>{
    state.openedTicket.listaDanneggiatiJmil = action.payload?.danneggiati;
    },
    setImportoSpesa: (state, action) =>{
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.datiPagamento.pagamentoSpesa.importo);
      state.allOpenedTicket[index].datiPagamento.pagamentoSpesa.importo = { ...tckObject };
      state.allOpenedTicket[index].datiPagamento.pagamentoSpesa.importo = action.payload;
    },
    setIncaricoSpese: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.datiPagamento.pagamentoSpesa.incaricato);
      state.allOpenedTicket[index].datiPagamento.pagamentoSpesa.incaricato = { ...tckObject };
      state.allOpenedTicket[index].datiPagamento.pagamentoSpesa.incaricato = action.payload;
    },
   getGaranziePagamentoIndennizzo: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.garanziePagamentoIndennizzo);
      state.allOpenedTicket[index].garanziePagamentoIndennizzo = { ...tckObject };
      state.allOpenedTicket[index].garanziePagamentoIndennizzo = action.payload;
    } ,
    setGaranziePagamentoIndennizzo: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.garanziePagamentoIndennizzoValue);
      state.allOpenedTicket[index].garanziePagamentoIndennizzoValue = { ...tckObject };
      state.allOpenedTicket[index].garanziePagamentoIndennizzoValue = action.payload;
    },
    setDanneggiatoIdPagamentoIndennizzo: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.danneggiatoIdPagamentoIndennizzo);
      state.allOpenedTicket[index].danneggiatoIdPagamentoIndennizzo = { ...tckObject };
      state.allOpenedTicket[index].danneggiatoIdPagamentoIndennizzo = action.payload;
    },
    setFormEnable: (state, action) => {
      state.openedTicket.formEnable= action.payload;
    },
    getListaBeneficiariInennizzo: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.listaBeneficiariIndennizzo);
      state.allOpenedTicket[index].listaBeneficiariIndennizzo = { ...tckObject };
      state.allOpenedTicket[index].listaBeneficiariIndennizzo = action.payload;
    },
    setDatiValidazione: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.datiValidazionePut);
      state.allOpenedTicket[index].datiValidazionePut = { ...tckObject };
      state.allOpenedTicket[index].datiValidazionePut = action.payload; 
    },
    setIdValidazione: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.idEsitazioneValidazione);
      state.allOpenedTicket[index].idEsitazioneValidazione = { ...tckObject };
      state.allOpenedTicket[index].idEsitazioneValidazione = action.payload; 
    },
    setImportoPagamento: (state, action)=>{
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      const tckObject = Object.assign({}, state.openedTicket?.importoPagmento);
      state.allOpenedTicket[index].importoPagmento = { ...tckObject };
      state.allOpenedTicket[index].importoPagmento = action.payload; 
    },
    setSelectedRadioIdPolizza: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      state.openedTicket.selectedRadioIdPolizza = action.payload; 
      state.allOpenedTicket[index].selectedRadioIdPolizza = action.payload; 
    }, 
    setDuplicatoId: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      state.openedTicket.duplicatoId = action.payload; 
      state.allOpenedTicket[index].duplicatoId = action.payload; 
    },    
    getDatiUtente: (state, action) => {
      state.userData = {};
      state.userData = { ...{}, ...action.payload };
    },
    setIdTitoloAmmOpenSinistro: (state, action) => {//
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      state.openedTicket.idTitoloAmmOpenSinistro = action.payload; 
      state.allOpenedTicket[index].idTitoloAmmOpenSinistro = action.payload; 
    },
    setPagamentiSpese: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      state.openedTicket.datiPagamento.pagamentoSpesa = action.payload;
      state.allOpenedTicket[index].datiPagamento.pagamentoSpesa = action.payload; 
    },
    setEmailMittenteSelectState: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      state.openedTicket.emailMittente = action.payload;
      state.allOpenedTicket[index].emailMittente = action.payload;
    },
    setListDuplicati: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      state.openedTicket.listaDuplicati = action.payload;
      state.allOpenedTicket[index].listaDuplicati = action.payload; 
    },
    setEsitoPerPostEsitazione: (state, action) => {
      // eslint-disable-next-line eqeqeq
      const index = state.allOpenedTicket.findIndex((taskItem) => taskItem.datiTask.idTask == state.openedTicket.datiTask.idTask);
      state.openedTicket.esitoPerPostEsitazione = action.payload;
      state.allOpenedTicket[index].esitoPerPostEsitazione = action.payload;
    }
  }

});

export const { 
  getTicketsLavorabili,
  getTicket,
  getTicketTree,
  getTicketsAssegnate,
  setVisibilityFilter,
  SearchTicket,
  DeleteTicket, 
  setOpenedTicketClaimData,
  setOpenedTicketAdminData,
  setOpenedTicketAdminDataRender,
  setOpenedTicketNPolizza,
  setOpenedTicketDatiCausa,
  setOpenedTicketDatiIncarico,
  setDenunciaMotivazione,
  setIdTicketInCharge,
  removeIdTicketInCharge,
  addOpenedTicket,
  setOpenedTicketChangePolizza,
  addOpenedTicketCached,
  removeOpenedTicket,
  setModifiedTicket,
  resetModifiedTicket,
  toogleLoading,
  getListaDanneggiati,
  getListaSoggettiCause,
  setListaSoggettiCausa,
  getRamiSinistro,
  VisibleAlertDangerMora,
  VisibleAlertWarningMora, 
  VisibleAlertNoDataEvDataRis, 
  setTitoloIsInCopertura,
  getGaranzieDanneggiato,
  setRamoGaranzia,
  setRamoGaranziaDanneggiato,
  getPrecedentiSinistri,
  getRiserveComplessive,
  getCauseIstruttoria,
  getIncarichiIstruttoria,
  getValidazioniIstruttoria,
  addIncaricato,
  removeIncaricato,
  showAlertIncaricato,
  setTipoIncaricato,
  getListaIncaricatiInQuadro,
  getListaIncaricatoNoQuadro,
  setIdCauseCollegate,
  getRiservaSpeseIncarico,
  setMotivazioneIncarico,
  setMotivazioneIncaricoNoQuadro,
  setNotaRiserveAuthority,
  setNotaRiserveAuthorityPagamento,
  setDisableComponentIncarico,
  getListaSearchPolizza,
  getListaSearchPolizzaCollettiva,
  getListaSearchCollettiva,
  setPolizza,
  setPolizzaTempAmministrativo,
  setNotaPromemoria,
  getListaPagamentiIstruttoria,
  setAlertPagamentiSpese,
  getListaDanneggiatiJmil,
  setImportoSpesa,
  setIncaricoSpese,
  getGaranziePagamentoIndennizzo,
  setGaranziePagamentoIndennizzo,
  setDanneggiatoIdPagamentoIndennizzo,
  setFormEnable,
  getListaBeneficiariInennizzo,
  setAlertPagamentiIndennizzoBeneficiari,
  setDatiValidazione,
  setIdValidazione,
  setImportoPagamento,
  setSelectedRadioIdPolizza,
  setDuplicatoId,
  getDatiUtente,
  setIdTitoloAmmOpenSinistro,
  setPagamentiSpese,
  setEmailMittenteSelectState,
  setListDuplicati,
  setEsitoPerPostEsitazione
} = TicketSlice.actions;

/**
 * Get lista Ticket Lavorabili che, al return viene popolato ticketsLavorabili tramiteil metododo getTicketsLavorabili
 * @function fetchTicketsLavorabili
 * @returns ritorna lista Ticket Lavorabili 
*/
export const fetchTicketsLavorabili = () => async (dispatch) => {
  const API_URI_CALL = `${API_URL}/api/v1/bff/task/lista-lavorabili`;

  const fetchData = async () => axiosInstance.get(API_URI_CALL);

  const [res, err] = await executor.executeAsync(fetchData);

  console.log('res', res);
  console.log('err', err);

  return dispatch(getTicketsLavorabili(res.data));
};

/**
 * Get lista Ticket Lavorabili che, al return viene popolato ticketsAssegnate tramite il metododo getTicketsAssegnate
 * @function fetchTicketsAssegnate
 * @returns ritorna lista Ticket Assegnati 
*/
export const fetchTicketsAssegnate = () => async (dispatch) => {
  const API_URI_CALL = `${API_URL}/api/v1/bff/task/lista-assegnate`;

  const fetchData = async () => axiosInstance.get(API_URI_CALL);

  const [res, err] = await executor.executeAsync(fetchData);

  console.log('res', res);
  console.log('err', err);

  return dispatch(getTicketsAssegnate(res.data));
};

/**
 * Get Dettaglio Ticket, contiene tutti i dati neccesari alla compialzione del task. E viene salvato nel nodo openedTicket e al nodo allOpenedTicket / In caso di Cache Attivo viene usato il metodo addOpenedTicketCached
 * @function fetchTicket
 * @param {String} taskId id del task
*/
export const fetchTicket = (taskId) => async (dispatch) => {
  dispatch(toogleLoading());
  dispatch(getTicket({}));

  if (taskId?.cache === false || taskId?.cache === undefined) {
    //const fetchData = async () => axiosInstance.get('/api/data/singleTicket/singleTicketData'); taskId.taskId
    const API_URI_CALL = `${API_URL}/api/v1/bff/task/dettaglio/${taskId.taskId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err', err);

    dispatch(addOpenedTicket(res.data));
    dispatch(getTicket(res.data));
  } else {
    setTimeout(() => {
      const datiTask = {"idTask": taskId.taskId};
      dispatch(addOpenedTicketCached({datiTask}));
  }, 1300);
  }

  return dispatch(toogleLoading());
};

/**
 * Get Dettaglio Ticket, contiene tutti i dati neccesari alla compialzione del task. In questo caso salviamo la response nel metodo getTicketTree che popola il nodo datiTaskFigli per l'abero laterale
 * @function fetchTicketTree
 * @param {String} taskId ID del task
 * @returns getTicketTree dati albero laterale
*/
export const fetchTicketTree = (taskId) => async (dispatch) => {
 // dispatch(toogleLoading());
  
    //const fetchData = async () => axiosInstance.get('/api/data/singleTicket/singleTicketData'); taskId.taskId
    const API_URI_CALL = `${API_URL}/api/v1/bff/task/dettaglio/${taskId.taskId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await  executor.executeAsync(fetchData);

    console.log('err', err);

  return  dispatch(getTicketTree(res.data));
     
 // return dispatch(toogleLoading());
};

export const rebuildModTicket = (taskId) => async (dispatch) => {
  dispatch(toogleLoading());
  dispatch(getTicket({}));

  //const fetchData = async () => axiosInstance.get('/api/data/singleTicket/singleTicketData'); taskId.taskId
  const API_URI_CALL = `${API_URL}/api/v1/bff/task/dettaglio/${taskId.taskId}`;
  const fetchData = async () => axiosInstance.get(API_URI_CALL);

  const [res, err] = await executor.executeAsync(fetchData);

  console.log('err', err);


  dispatch(setOpenedTicketChangePolizza(res.data));
  dispatch(getTicket(res.data));

  // dispatch(resetModifiedTicket());
  return dispatch(toogleLoading());
};

/**
 * Get Lista Danneggiati, i dati della response tramite il metodo getListaDanneggiati vengono salvati nel nodo listaDanneggiati, viene anche salvato il ramo completo tramite setRamoGaranziaDanneggiato nel nodo ramoGaranziaDanneggiato e il nodo con due cifre tramite il metodo setRamoGaranzia nel nodo ramoGaranziaPut
 * @function fetchListaDanneggiati
 * @param {uuID} idSinistro ID sinistro
 * @returns getListaDanneggiati lista Danneggiati
*/
export const fetchListaDanneggiati = (idSinistro) => async (dispatch) => {
  if (idSinistro) {
    const API_URI_CALL = `${API_URL}/api/v1/bff/denunce/lista/danneggiati/${idSinistro}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err', err);

    if (res.data.length>0) {
       //ramoGaranziaDanneggiato:"0013"
       dispatch(setRamoGaranziaDanneggiato(res.data[0].ramoGaranzia));
    
      const inputValue = res.data[0].ramoGaranzia;
      let outputValue = '';
      //Prendo ultime due cifre del ramo
           if (parseInt(inputValue, 10) < 10) {
             outputValue = inputValue.slice(-2);
           } else {
             for (let i = 0; i < inputValue.length; i++) {
               const digit = parseInt(inputValue[i], 10);
               if (digit > 0) {
                 outputValue += digit;
               }
             }
           }
      //ramoGaranziaPut:"13"
      dispatch(setRamoGaranzia(outputValue));
    }
    return dispatch(getListaDanneggiati(res.data));
  }
  return null;
};

/**
 * Get Lista Rmi che popola la selec Rami tramite il metodo getRamiSinistro e popola il nodo listaRamiSinistro
 * @function fetchListaRamiSinistro
 * @param {String} nPolizza Numero Polizza
 * @param {String} idSinistro ID Sinistro
 * @param {String} idTitoloAmministrativo ID Titolo amministrativo
 * @param {String} idBene ID Bene
 * @returns getRamiSinistro
*/
export const fetchListaRamiSinistro = (nPolizza, idSinistro, idTitoloAmministrativo, idBene) => async (dispatch) => {
  if (nPolizza && nPolizza !== 'N/A' && idSinistro && idTitoloAmministrativo) {
    let queryParamPolizza;
		if(idBene){
      queryParamPolizza = `?idBene=${idBene}`
			
		}else {
			queryParamPolizza = `?idTitolo=${idTitoloAmministrativo}`
		}
    const API_URI_CALL = `${API_URL}/api/v1/bff/denunce/rami/${nPolizza}/${idSinistro}${queryParamPolizza}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err', err);

    return dispatch(getRamiSinistro(res.data));
  }
  return null;
};

/**
 * Get Lista Garanzie per Danneggiato, ritorna le garanzie(prestazioni) tramite il metodo getGaranzieDanneggiato che salverà i dati nel nodo listaGaranzieDanneggiato. In base all idBene verrà utilizzato un Paramquery diverso idBene=${idBene} o idTitolo=${idTitoloJMIL}
 * @function fetchListaGaranzieDanneggiato
 * @param {String} taskId ID del task
 * @param {String} danneggiatoId ID del Danneggiato
 * @param {String} codiceRamo codice del ramo
 * @param {String} idTitoloJMIL ID Titlo amministrativo JMIL
 * @param {String} idBene ID del Bene
 * @returns getGaranzieDanneggiato ritorna lista garanzie
*/
export const fetchListaGaranzieDanneggiato = (taskId, danneggiatoId, codiceRamo, idTitoloJMIL, idBene) => async (dispatch) => {

  if (taskId && danneggiatoId && codiceRamo) {
     let queryParamPolizza;
		if(idBene){
      queryParamPolizza = `idBene=${idBene}`
			
		}else {
			queryParamPolizza = `idTitolo=${idTitoloJMIL}`
		}

    /* Da smontare e rifare correttamente */
    const onlyDigits = parseInt(codiceRamo, 10); // Rimuovo tutte le lettere dalla stringa

    const newStringCodiceRamo = `00${onlyDigits.toString()}`;

    const subStringRamo = newStringCodiceRamo.slice(-2);
  
    const API_URI_CALL = `${API_URL}/api/v1/bff/denunce/garanzie/${taskId}/${danneggiatoId}?codiceRamo=${subStringRamo}&${queryParamPolizza}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err', err);

    return dispatch(getGaranzieDanneggiato(res.data));

  }
  return null;
};

/**
 * Get Lista Precedenti Sinistri, tramite il metodo getPrecedentiSinistri i dati vengono dalvati nel nodo precedentiSinistri per popolare la tabella Precendenti Sinistri
 * @function fetchPrecendentiSinistri
 * @param {String} nPolizza Numero Polizza
 * @param {String} idSinistro ID Sinistro
 * @returns getPrecedentiSinistri popola la tabella Precendenti Sinistri
*/
export const fetchPrecendentiSinistri = (nPolizza, idSinistro) => async (dispatch) => {
  if (nPolizza && nPolizza !== 'N/A' && idSinistro) {
    const API_URI_CALL = `${API_URL}/api/v1/bff/denunce/lista/sinistri-precedenti/${nPolizza}/id/${idSinistro}`;
    //this is shit
    const uuID = crypto.randomUUID();
    const userToken = JSON.parse(localStorage.getItem('userInfo'));
    if (userToken) {
      axiosInstance.defaults.headers.common = { Authorization: `Bearer ${userToken.access_token}`, requestId: uuID, page: 0, size: 100 };
    }
    //this is shit
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err', err);

    return dispatch(getPrecedentiSinistri(res.data));
  }
  return null;
};

/**
 * Get Riserve complessive, tramite il metodo getRiserveComplessive viene popolato il nodo riserveComplessive, per popolare il componente delle riserve complessive
 * @function fetchRiserveComplessive
 * @param {String} idSinistro ID Sinistro
 * @returns getRiserveComplessive popolare risreve complessive
*/
export const fetchRiserveComplessive = (idSinistro) => async (dispatch) => {
  if (idSinistro) {
    const API_URI_CALL = `${API_URL}/api/v1/bff/denunce/lista/riserve-complessive/${idSinistro}`;
    //this is shit
    const userToken = JSON.parse(localStorage.getItem('userInfo'));
    if (userToken) {
      axiosInstance.defaults.headers.common = { Authorization: `Bearer ${userToken.access_token}`, quota: 0 }; //quota da capire se deve essere dinamico
    }
    //this is shit
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err getRiserveComplessive', err);

    return dispatch(getRiserveComplessive(res.data));
  }
  return null;
};

/**
 * Get Lista Cause Istruttoria, tramite il metodo getCauseIstruttoria viene popolato il nodo causeIstruttoria, per popolare la tabella cause collegate al sinistro
 * @function fetchCauseIstruttoria
 * @param {String} idSinistro ID Sinistro
 * @returns getCauseIstruttoria popola tabella CauseIstruttoria
*/
export const fetchCauseIstruttoria = (idSinistro) => async (dispatch) => {
  if (idSinistro) {
    const API_URI_CALL = `${API_URL}/api/v1/bff/cause/lista/${idSinistro}?size=100&page=0`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err', err);

    return dispatch(getCauseIstruttoria(res.data));
  }
  return null;
};

/**
 * Get Lista Soggetti Causa, tramite il metodo getListaSoggettiCause, viene popolato il nodo listaSoggetti, serve per popolare la select dei possibili soggetti coinvoliti in una casua nel task Cause
 * @function fetchListaSoggettiCausa
 * @param {String} causaId ID Causa
 * @returns getListaSoggettiCause popola select Soggetti Causa
*/
export const fetchListaSoggettiCausa = (causaId) => async (dispatch) => {
  if (causaId) {
    const API_URI_CALL = `${API_URL}/api/v1/bff/cause/soggetti/${causaId}?size=20&page=0`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err', err);

    return dispatch(getListaSoggettiCause(res.data));
  }
  return null;
};

/**
 * Get Lista Incarichi in Istruttoria, tramite il metodo getIncarichiIstruttoria viene popolato il nodo incarichiIstruttoria, popola tabella Incarichi in Istruttoria
 * @function fetchIncarichiIstruttoria
 * @param {String} idSinistro ID Sinistro
 * @returns getIncarichiIstruttoria popola tabella Incarichi in Istruttoria
*/
export const fetchIncarichiIstruttoria = (idSinistro) => async (dispatch) => {
  if (idSinistro) {
    const API_URI_CALL = `${API_URL}/api/v1/bff/incarichi/lista/${idSinistro}?size=100&page=0`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err', err);

    return dispatch(getIncarichiIstruttoria(res.data));
  }
  return null;
};

/**
 * Get Lista Incarichi in Quadro, tramite il metodo getListaIncaricatiInQuadro viene popolato il nodo listaIncaricatiInQuadro, nel task TIpo Incarico quando viene selezionata una specilizzazione viene popolata la tabella degli incaricati in quadro.
 * @function fetchListaIncarichiInQuadro
 * @param {String} specializzazzione Tipo specilizzazione
 * @returns getListaIncaricatiInQuadro popola tabella Incaricati in quadro
*/
export const fetchListaIncarichiInQuadro = (specializzazzione) => async (dispatch) => {
  if (specializzazzione) {
    const API_URI_CALL = `${API_URL}/api/v1/bff/incarichi/incaricati/${specializzazzione}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err', err);

    return dispatch(getListaIncaricatiInQuadro(res.data));
  }
  return null;
};

/**
 * Get Lista Incarichi No Quadro, tramite il metodo getListaIncaricatoNoQuadro viene popolato il nodo listaIncaricatoNoQuadro, nel task Tipo Incarico quando viene selezionata il radio Button fiduciario fuori accordo quadro, viene popolata la tabella degli incaricati No quadro.
 * @function fetchListaIncaricatoNoQuadro
 * @param {String} incaricatoId ID Incaricato
 * @returns getListaIncaricatoNoQuadro popola tabella Incaricati No quadro
*/
export const fetchListaIncaricatoNoQuadro = (incaricatoId) => async (dispatch) => {
  if (incaricatoId) {
    const API_URI_CALL = `${API_URL}/api/v1/bff/incarichi/incaricato/${incaricatoId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err', err);

    return dispatch(getListaIncaricatoNoQuadro(res.data));
  }
  return null;
};

/**
 * Get Riserva Spesa Incaricato, tramite il metodo getRiservaSpeseIncarico viene popolato il nodo riservaSpeseIncarico, si visualizza la riserva riserva all'incaricato scelto nel gtask incarichi
 * @function fetchRiserveSpeseIncarico
 * @param {String} riservaSpesaId ID Riserva Spesa
 * @returns getRiservaSpeseIncarico popola component Riserva Incarico
*/
export const fetchRiserveSpeseIncarico = (riservaSpesaId) => async (dispatch) => {
  if (riservaSpesaId) {
    const API_URI_CALL = `${API_URL}/api/v1/bff/incarichi/riserva-spesa/${riservaSpesaId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err', err);

    return dispatch(getRiservaSpeseIncarico(res.data));
  }
  return null;
};

/**
 * Get Lista Validazioni, tramite il metodo getValidazioniIstruttoria viene popolato il nodo validazioniIstruttoria, popola tabella validazioni in istruttoria
 * fetchValidazioniIstruttoria
 * @param {String} idSinistro ID Sinistro
 * @returns getValidazioniIstruttoria popola tabella validazioni in istruttoria
*/
export const fetchValidazioniIstruttoria = (idSinistro) => async (dispatch) => {
  if(idSinistro){
    const API_URI_CALL = `${API_URL}/api/v1/bff/validazioni/lista/${idSinistro}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err',err);

    return dispatch(getValidazioniIstruttoria(res.data));
  }
  return null;
};

/**
 * Trova nuova polizza, tramite il metodo getListaSearchPolizza viene popolato il nodo listaSearchPolizza, popola tabella con la lista delle possibili polizze.
 * @function fetchSearchPolizza
 * @param {String} polizza Numero polizza
 * @returns getListaSearchPolizza trova polizza
*/
export const fetchSearchPolizza = (polizza) => async (dispatch) => {
  dispatch(getListaSearchPolizzaCollettiva([]));
  const API_URI_CALL = `${API_URL}/api/v1/bff/overx/polizze/generica/find/${polizza}?limit=10`;
  const fetchData = async () => axiosInstance.get(API_URI_CALL);

  const [res, err] = await executor.executeAsync(fetchData);

  console.log('err',err);
  if(res.data){
    return dispatch(getListaSearchPolizza(res.data));
  }
  return 0;
};

/**
 * Get Search Polizza Collettiva, tramite il metodo getListaSearchPolizzaCollettiva viene popolato il nodo listaSearchPolizzaCollettiva
 * @function fetchSearchPolizzaCollettiva
 * @param {String} polizza Numero Polizza
 * @returns 
*/
export const fetchSearchPolizzaCollettiva = (polizza) => async (dispatch) => {
  dispatch(getListaSearchPolizza([]));
  const API_URI_CALL = `${API_URL}/api/v1/bff/beneCollettivo/numeroPolizza/${polizza}`;
  const fetchData = async () => axiosInstance.get(API_URI_CALL);

  const [res, err] = await executor.executeAsync(fetchData);

  console.log('err',err);
  if(res.data){
    return dispatch(getListaSearchPolizzaCollettiva(res.data));
  }
  return 0;
};

/**
 * Chiamata per descrizione bene colletivo, tramite il metodo getListaSearchCollettiva viene popolato il nodo listaSearchCollettiva
 * @function fetchSearchCollettiva
 * @param {String} descrizioneBene 
 * @returns getListaSearchCollettiva
*/
export const fetchSearchCollettiva = (descrizioneBene) => async (dispatch) => {
  if(descrizioneBene) {
    const API_URI_CALL = `${API_URL}/api/v1/bff/beneCollettivo/descrizioneOggetto/${descrizioneBene}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err',err);
    if(res.data){
      return dispatch(getListaSearchCollettiva(res.data));
    }
  }
  return 0;
};

/**
 * Get Lista Pagamenti, tramite il metodo getListaPagamentiIstruttoria viene popolato il nodo listaPagamenti, popola tabella Pagamenti Istruttoria
 * @function fetchListaPagamenti
 * @param {String} sinistroId ID Sinstro
 * @returns getListaPagamentiIstruttoria popola tabella Pagamenti Istruttoria
*/
export const fetchListaPagamenti = (sinistroId) => async (dispatch) => {
  if(sinistroId){
    const API_URI_CALL = `${API_URL}/api/v1/bff/pagamenti/lista/${sinistroId}/?limit=100`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err',err);
    if(res.data){
      return dispatch(getListaPagamentiIstruttoria(res.data));
    }
    return 0;
  }
  return null;
};

/**
 * Get Lista Garanzie pagamenti Indennizzo, tramite il metodo getGaranziePagamentoIndennizzo viene popolato il nodo garanziePagamentoIndennizzo, dopo aver selezionato un danneggiato nella quitenza viene popolata la tabella delle garanzie per Danneggiato.
 * @function fetchListaGaranziePagamentoIndennizzo
 * @param {String} danneggiatoId ID Danneggiato
 * @param {String} pagamentoId IDPagamento
 * @returns getGaranziePagamentoIndennizzo lista tabella delle garanzie per Danneggiato
*/
export const fetchListaGaranziePagamentoIndennizzo = (danneggiatoId, pagamentoId) => async (dispatch) => {
  if(danneggiatoId && pagamentoId){
    const API_URI_CALL = `${API_URL}/api/v1/bff/pagamenti/garanzie/${danneggiatoId}/${pagamentoId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err',err);
    if(res.data){
      return dispatch(getGaranziePagamentoIndennizzo(res.data));
    }
    return 0;
  }
  return null;
};

//{{baseUrlOsBff}}/denunce/lista/danneggiatiJmil/{{nDenuncia}}/{{codiceProdotto}}
/**
 * Lista Danneggiati JMil, tramite il metodo getListaDanneggiatiJmil viene mìpopolato il nodo listaDanneggiatiJmil
 * @function fetchDanneggiatiJmil
 * @param {String} nDenuncia Numero Denuncia
 * @param {String} codiceProdotto Codice Prodotto
 * @param {String} codiceLiquidatore Codice Liquidatore
 * @param {Boolean} isOverx Se è polizza OverX
 * @returns getListaDanneggiatiJmil
 */
export const fetchDanneggiatiJmil = (nDenuncia, codiceProdotto,codiceLiquidatore, isOverx) => async (dispatch) => {
  if(nDenuncia && codiceProdotto && codiceLiquidatore) {
    const API_URI_CALL = `${API_URL}/api/v1/bff/denunce/lista/danneggiatiJmil/${nDenuncia}/${codiceProdotto}/${codiceLiquidatore}/${isOverx}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err',err);
    if(res.data){
      return dispatch(getListaDanneggiatiJmil(res.data));
    }
    return 0;
  }
  return null;
};

/**
  Get Lista Beneficiari Indennizzo, tramite il metodo getListaBeneficiariInennizzo viene popolato il nodo listaBeneficiariIndennizzo, tabella dei fiduciari in Pagamenti Indennizzo
 * @function fetchListaBeneficiariIndennizzo
 * @param {String} pagamentoId ID Pagamento
 * @returns getListaBeneficiariInennizzo tabella dei fiduciari
*/
export const fetchListaBeneficiariIndennizzo = (pagamentoId) => async (dispatch) => {// todo manca chiamata
  if(pagamentoId) {
    const API_URI_CALL = `${API_URL}/api/v1/bff/pagamenti/lista/beneficiario-indennizzo/${pagamentoId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err',err);
    if(res.data){
      return dispatch(getListaBeneficiariInennizzo(res.data));
    }
    return 0;
  }
  return null;
};

/**
 * Get Informazioni Utente, tramite il metodo getDatiUtente viene popolato il nodo userData
 * @function fetchUserData
 * @param {String} userId ID User
 * @returns getDatiUtente Info Utente
 */
export const fetchUserData = (userId) => async (dispatch) => {// todo manca chiamata
  if(userId) {
    const API_URI_CALL = `${API_URL}/api/v1/bff/utenti/${userId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err',err);
    if(res.data){
      localStorage.setItem("userData", JSON.stringify(res.data)); //this is shit
      return dispatch(getDatiUtente(res.data));
    }
    return 0;
  }
  return null;
};

/**
 * in base al nomeEsitazione.toLowerCase() === "pagamento annullato" || nomeEsitazione.toLowerCase() === "quietanza non accettata" viene fatta una chiamata per settare lo staoo del pagamento OK o KO
 * @function fetchPagamentoStatus
 * @param {String} pagamentoId ID Pagamento
 * @param {String} value OK o KO
 * @param {String} tipoPagamento Tipo pagamento
*/
export const fetchPagamentoStatus = (pagamentoId,value,tipoPagamento) => async () => {
  if(pagamentoId && value) {  
    let API_URI_CALL="";
    if(tipoPagamento==="PAGAMENTO_SPESA")
      API_URI_CALL=`${API_URL}/api/v1/bff/pagamenti/pagamentoSpesa/statoPagamento/${pagamentoId}`;
    else
      API_URI_CALL = `${API_URL}/api/v1/bff/pagamenti/pagamentoIndennizzo/statoPagamento/${pagamentoId}`;
    const fetchData = async () => axiosInstance.put(API_URI_CALL,{statoPagamento:value});

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('res',res);
    console.log('err',err);
  }
  return 0;
};

/**
 * quando viene effettuato un esito di fiduciario nominato settiamo sull'incaricato lo stato di nominato
 * @function fetchPagamentoStatus
 * @param {String} id ID incaricato
*/
export const fetchIncaricatoStatus = (id) => async () => {
  if(id) {  
    const API_URI_CALL=`${API_URL}/api/v1/bff/incarichi/stato/${id}`;
    const fetchData = async () => axiosInstance.put(API_URI_CALL,{statoIncarico:"NOMINATO"});

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('res',res);
    console.log('err',err);
  }
  return 0;
};

/**
 * Get Informazioni Utente, tramite il metodo getDatiUtente viene popolato il nodo userData
 * @function fetchRicercaDuplicato
 * @param {String} text testo da cercare
 * @param {String} type tipo:id/polizza/sinistro
 * @returns setListDuplicati lista elementi della ricerca
 */
 export const fetchRicercaDuplicato = (text,type) => async (dispatch) => {// todo manca chiamata
  let API_URI_CALL;
  if(text.trim().length>0) {
    switch(type){
      case "id":
        API_URI_CALL = `${API_URL}/api/v1/bff/denunce/cercaSinistriAndDenunce/idTask/${text}`;
        break; 
      case "polizza":
        API_URI_CALL = `${API_URL}/api/v1/bff/denunce/cercaSinistriAndDenunce/numeroPolizza/${text}`;
        break; 
      case "sinistro":
        API_URI_CALL = `${API_URL}/api/v1/bff/denunce/cercaSinistro/sinistroId?idPerSinistro=${text}`;
        break;
      default:
          break;
    }
    const fetchData = async () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err',err);
    if(res.data && res.data.length>0){
      return dispatch(setListDuplicati(res.data));
    }
    if(res.data){
      return dispatch(setListDuplicati([res.data]));
    }
    return dispatch(setListDuplicati([]));
    // return dispatch(setListDuplicati([
    //   { id: "10", numeroPolizza: "20", numeroSinistro: "30", esito: "test" },
    //   { id: "100", numeroPolizza: "200", numeroSinistro: "300", esito: "test2" }
    // ]));
 
  }
  return dispatch(setListDuplicati([]));
};

/**
 * Get Informazioni Utente, tramite il metodo getDatiUtente viene popolato il nodo userData
 * @function fetchDuplicatoSalva
 * @param {String} id ID del task
 * @returns getDatiUtente Info Utente
 */
 export const fetchDuplicatoSalva = (duplicatoId,emailId,paramsFetchPostEsita,taskId,taskIdInCharge) => async (dispatch) => {// todo manca chiamata
  if(duplicatoId) {
    const payload={
      "idEmail": emailId,
      "codicePraticaDaAssociare": duplicatoId,
      "taskIdAttuale": taskId,
      "esitaTask":paramsFetchPostEsita
    }
    const API_URI_CALL = `${API_URL}/api/v1/bff/email/riconciliazioneTask`;
    const fetchData = async () => axiosInstance.put(API_URI_CALL,payload);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('err',err);
    if(res.data){
      //--> gestione toast
      const uuID = crypto.randomUUID();  //simuliamo una requestId
      const itemMessageToast = {
        "requestId": uuID,
        "entityName": "Esitazione task",
        "taskId": taskId,
        "fetchToEval": "Esitazione",
        "idTaskPadre":"",
        "navigate":true,
        "loader":""
      } //genera l'eval di un fetch

      dispatch(setTotalItemMessageToast(itemMessageToast));
      //Simuliamo la risposta
      const itemOk = `{"requestId":"${uuID}", "operation":{"status":"SUCCESS", "statusCode": "7200"}}`
      const itemOkObj = { "data": itemOk }
      //simuliamo il dispatch della ws
      dispatch(checkTotalItemMessageToast(itemOkObj));

      // console.log('Res on Esiti ', response.data);
      // --> gestione NavTab
      dispatch(removeTaskToNav({ taskId }));
      dispatch(removeIdTicketInCharge(taskId)); //free frontend
      if (taskIdInCharge === `${taskId};`) {
        //se esistono altri ticket in modalità di modifica occorre lasciare invariato lo stato del customizer
        //diversamente andiamo in toggle
        dispatch(EnabledDisabledStateTrueFalsePresaCarico());
      }
      dispatch(removeOpenedTicket({ taskId })); //TicketReducer
    }
    return 0;
 
  }
  return null;
};


export default TicketSlice.reducer;
